export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10551.4805202b.jpg";